import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'clsx';
import debounce from 'lodash/debounce';
import React from 'react';
import { connect } from 'react-redux';
import {
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
} from 'react-stripe-elements';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import uuidv4 from 'uuid/v4';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';

// TODO: Refactor this style
const createOptions = {
  style: {
    base: {
      fontSize: '18px',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#8f9ba5',
      },
    },
    invalid: {
      color: '#b90000',
    },
  },
};

const styles = {
  iconLoading: {
    width: 22,
  },
  iconSecure: {
    width: 18,
    marginBottom: 2,
  },
};

const renderCheckboxField = ({ input, placeholder, type, title }) => (
  <label style={{ marginTop: 5, paddingRight: 5 }}>
    <input type={type} {...input} />
    <b style={{ borderRadius: 2 }} /> {title}
  </label>
);

@withI18next()
class PaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorCardNumber: '',
      errorExpiry: '',
      errorCVC: '',
      errorToken: '',
      modal: false,
      subscribing: false,
    };
    this.onSubmit = debounce(this.onSubmit, 500);
  }

  componentDidMount() {
    this.idempotencyTokenInterval = setInterval(() => {
      this.idempotencyToken = uuidv4();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.idempotencyTokenInterval);
  }

  handleChange = (change) => {
    const { elementType, error } = change;
    switch (elementType) {
      case 'cardNumber':
        this.setState({ errorCardNumber: error ? error.message : '' });
        break;
      case 'cardExpiry':
        this.setState({ errorExpiry: error ? error.message : '' });
        break;
      case 'cardCvc':
        this.setState({ errorCVC: error ? error.message : '' });
        break;
      default:
        break;
    }
  };

  onSubmit = (values) => {
    const updater = (state) => ({ modal: !state.modal });
    const callback = async () => {
      const { stripe, onSubmit } = this.props;
      const result = await stripe.createToken();
      if (result.error) {
        const { code, message } = result.error;
        this.setState({
          errorCardNumber: code.includes('number') ? message : '',
          errorExpiry: code.includes('expiry') ? message : '',
          errorCVC: code.includes('cvc') ? message : '',
          errorToken: code.includes('card_declined') ? message : '',
          subscribing: false,
        });
      } else {
        onSubmit({
          values,
          payload: result,
          idempotencyToken: this.idempotencyToken,
        });
      }
    };
    this.setState(updater, callback);
  };

  handleSubscribe = () => {
    this.setState({ subscribing: true });
    const { handleSubmit } = this.props;
    handleSubmit(this.onSubmit)();
  };

  renderInputError = (inputError) => {
    const containerClassName = classNames(
      'error-messages',
      inputError && 'show-message',
    );
    return (
      <div className={containerClassName}>
        {inputError && (
          <div className="text-center" style={{ marginTop: '-7px' }}>
            <div
              className={`${Config.getPrefixContent(
                'arrow-up',
              )} arrow-up display-inline-block`}
            />
            <div
              className={`${Config.getPrefixContent(
                'bg-yellow',
              )} field-message-error animated`}
              style={{ marginTop: '-8px' }}
            >
              {inputError}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderCardPaymentMethod = () => {
    const {
      pristine,
      handleSubmit,
      submitting,
      messageError,
      agree,
      disable,
      t,
      typePlan,
    } = this.props;
    const {
      errorCardNumber,
      errorExpiry,
      errorCVC,
      errorToken,
      subscribing,
    } = this.state;
    console.log('typePlan trong Payment Form', typePlan);

    return (
      <div className="payment-method-content-card">
        {/* <Collapse isOpened> */}
        <div className="padding-10 credit-card-stripe">
          <div style={{ position: 'relative' }} className="pt15">
            <label className="pb5">{t('register_premium_card_number')}</label>
            <CardNumberElement
              className="bg-input-credit"
              onChange={this.handleChange}
              {...createOptions}
            />
            {this.renderInputError(errorCardNumber)}
          </div>
          <div style={{ position: 'relative' }} className="pt15">
            <label className="pb5">
              {t('register_premium_expiration_date')}
            </label>
            <CardExpiryElement
              className="bg-input-credit"
              onChange={this.handleChange}
              {...createOptions}
            />
            {this.renderInputError(errorExpiry)}
          </div>
          <div style={{ position: 'relative' }} className="pt15">
            <label className="pb5">CVC</label>
            <CardCVCElement
              className="bg-input-credit"
              onChange={this.handleChange}
              {...createOptions}
            />
            {this.renderInputError(errorCVC)}
          </div>
        </div>
        {/* </Collapse> */}
        <div className="padding-10" style={{ textAlign: 'center' }}>
          <label style={{ marginTop: 5, paddingRight: 5 }}>
            <Field
              name="agree"
              id="employed"
              title={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('register_premium_card_number_content7'),
                  }}
                />
              }
              component={renderCheckboxField}
              type="checkbox"
            />
          </label>
          {/* <div>
            <Link href="/terms-premium">
              <a className={`color-${Config.serviceType}`}>
                {t(
                  Config.getPrefixContent(
                    'register_premium_card_number_content4',
                  ),
                )}
              </a>
            </Link>
            <br />
            <Link href="/privacy-policy">
              <a className={`color-${Config.serviceType}`}>
                {t('register_premium_card_number_content5')}
              </a>
            </Link>
          </div> */}
        </div>
        <div className="pb30 text-center">
          <button
            disabled={
              disable || !agree || pristine || submitting || subscribing
            }
            className="button-payment"
            onClick={this.handleSubscribe}
          >
            {subscribing ? (
              <FontAwesomeIcon
                icon={faSpinner}
                fixedWidth
                style={styles.iconLoading}
                pulse
              />
            ) : (
              t('credit_premium_benefit_button2')
            )}
          </button>
        </div>
        {typePlan === 'MONTHLY' && (
          <div
            className="text-center"
            style={{ fontStyle: 'italic', fontWeight: 700 }}
            dangerouslySetInnerHTML={{
              __html: t('register_premium_card_number_content8_monthly'),
            }}
          />
        )}
        {typePlan !== 'MONTHLY' && (
          <div
            className="text-center"
            style={{ fontStyle: 'italic', fontWeight: 700 }}
            dangerouslySetInnerHTML={{
              __html: t('register_premium_card_number_content8'),
            }}
          />
        )}
      </div>
    );
  };

  render() {
    const { t, stripe } = this.props;
    // const iconSecure = <FontAwesomeIcon icon={faShieldAlt} style={styles.iconSecure} />;
    return (
      <form className="register-premium-form">
        <div
          className="credit-card-infor"
          style={{
            // display: 'flex',
            paddingBottom: 30,
            alignItems: 'center',
          }}
        >
          {this.renderCardPaymentMethod()}
        </div>

        <ul className="secure-notes">
          <li className="secure-note-item">
            {t('register_premium_card_number_content6')}
          </li>
          <li className="secure-note-item">
            {t('register_premium_card_number_content9')}
          </li>
        </ul>
        <style jsx global>
          {`
            .register-premium-form .button-shadow-lg {
              height: 60px;
              padding-left: 35px;
              padding-right: 35px;
            }

            a:hover {
              color: #3a4ed7;
              text-decoration: underline !important;
              opacity: 0.8;
            }

            a:focus {
              color: #3a4ed7;
              text-decoration: none !important;
              opacity: 1 !important;
            }

            .button-payment {
              padding: 10px 24px;
              height: 48px;
              background: ${themeVariables.colors.primary};
              border-radius: ${Config.isIllustAC() ? '40px' : '4px'};
              font-size: 16px;
              line-height: 28px;
              color: #ffffff;
              font-weight: 700;
              border: none;
            }

            .button-payment:disabled {
              opacity: 0.5;
            }

            .register-premium-form .ill_bg-yellow {
              background-color: #d73a4e;
            }

            .register-premium-form .design_bg-yellow {
              background-color: #ffa823;
            }

            .register-premium-form .photo_bg-yellow {
              background-color: #509bdc;
            }

            .register-premium-form .silhouette_bg-yellow {
              background-color: #41b9b8;
            }

            .register-premium-form .ill_arrow-up {
              border-bottom: 7px solid #d73a4e;
            }

            .register-premium-form .design_arrow-up {
              border-bottom: 7px solid #ffa823;
            }

            .register-premium-form .photo_arrow-up {
              border-bottom: 7px solid #509bdc;
            }

            .register-premium-form .silhouette_arrow-up {
              border-bottom: 7px solid #41b9b8;
            }

            .register-premium-form .button-shadow {
              border-radius: 60px;
              color: #fff;
            }

            .register-premium-form .button-design_ac {
              background: #ffa823;
              box-shadow: 0 5px 1px -1px #774d17;
            }

            .register-premium-form .button-illust_ac {
              background: #d73a4e;
              box-shadow: 0 5px 1px -1px #5e282e;
            }

            .register-premium-form .button-photo_ac {
              background: #509bdc;
              box-shadow: 0 5px 1px -1px #1c5362;
            }

            .register-premium-form .button-shilhouette_ac {
              background: #41b9b8;
              box-shadow: 0 5px 1px -1px #2b5e5a;
            }

            .modal-register-premium .button-shadow-lg {
              height: 35px;
              font-size: 12px;
            }

            .modal-register-premium .button-shadow {
              border-radius: 60px;
            }

            .modal-register-premium .button-design_ac {
              background: #ffa823;
              box-shadow: 0 5px 1px -1px #774d17;
            }

            .modal-register-premium .button-illust_ac {
              background: #d73a4e;
              box-shadow: 0 5px 1px -1px #5e282e;
            }

            .modal-register-premium .button-photo_ac {
              background: #509bdc;
              box-shadow: 0 5px 1px -1px #1c5362;
            }

            .modal-register-premium .button-shilhouette_ac {
              background: #41b9b8;
              box-shadow: 0 5px 1px -1px #2b5e5a;
            }

            .modal-register-premium .button-shadow {
              padding-right: 25px;
              padding-left: 25px;
              color: #fff;
              border: none;
              font-weight: 400;
            }

            .modal-register-premium .dialog-header {
              color: #fff;
              padding-top: 15px;
              border-top-right-radius: 3px;
              border-top-left-radius: 3px;
              padding-bottom: 15px;
            }

            .modal-register-premium .ill_dialog-header {
              background-color: #d73a4e;
            }

            .modal-register-premium .design_dialog-header {
              background-color: #ffa823;
            }

            .modal-register-premium .sil_dialog-header {
              background-color: #41b9b8;
            }

            .modal-register-premium .photo_dialog-header {
              background-color: #509bdc;
            }
          `}
        </style>
      </form>
    );
  }
}

let registerPremiumForm = reduxForm({
  form: 'PaymentForm',
})(PaymentForm);

const selector = formValueSelector('PaymentForm');
registerPremiumForm = injectStripe(
  connect((state) => {
    const agree = selector(state, 'agree');
    return { agree };
  })(registerPremiumForm),
);

export default registerPremiumForm;
